export const PRICE_TYPE_NAMES = {
  rrp: 'Retail',
  ws: 'Wholesale',
  ic: 'Cost',
};

export const DEFAULT_PRICE_TYPE = 'rrp';
